<template>
    <div class="mb-12 space-y-12">
        <prime-message
            :closable="false"
            severity="success"
            :pt="{
                text: {
                    class: 'w-full'
                }
            }"
            :pt-options="{
                mergeProps: true
            }"
        >
            <div class="flex w-full items-center justify-between gap-16">
                <div>{{ resetMessage }}</div>

                <prime-button
                    :label="t('checkoutSuccess.resetKioskNow')"
                    severity="secondary"
                    @click="$emit('reset')"
                />
            </div>
        </prime-message>

        <div
            v-if="false"
            class="flex items-center justify-between gap-4"
        >
            <prime-button
                :label="continueAsLabel"
                outlined
                @click="$emit('continue')"
            />

            <div class="flex-1">
                {{ t('checkoutSuccess.kioskContinueMessage') }}
            </div>
        </div>
    </div>

    <checkout-success-kiosk-display
        v-if="checkoutResultData.includedInvoice"
        :checkout-result-data="checkoutResultData.data"
    />

    <contract-success
        v-else
        :ref-number="checkoutResultData.data.referenceNumber"
    />
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import CheckoutSuccessKioskDisplay from '~/components/Checkout/CheckoutSuccessKioskDisplay.vue'
import PrimeMessage from 'primevue/message'
import PrimeButton from 'primevue/button'
import { computed, ref } from 'vue'
import { useIntervalFn } from '@vueuse/core'
import type { KioskSuccessData } from '~/composables/use-kiosk-success'
import ContractSuccess from '~/components/Checkout/ContractSuccess.vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    checkoutResultData: KioskSuccessData
}>()

const emit = defineEmits<{
    (e: 'reset'): void
    (e: 'continue'): void
}>()

const { t } = useI18n({ useScope: 'global' })

useHead({
    title: t('success')
})

const resetCounter = ref<number | null>(10)
const resetMessage = computed(() => {
    const secondsRemaining = resetCounter.value ?? 0

    // Keep the countdown copy grammatical as the remaining seconds change.
    return t(
        'checkoutSuccess.kioskResetMessage',
        { seconds: secondsRemaining },
        secondsRemaining
    )
})

useIntervalFn(() => {
    if (resetCounter.value !== null) {
        resetCounter.value -= 1
        if (resetCounter.value < 1) {
            resetCounter.value = null
            emit('reset')
        }
    }
}, 1000)

// TODO: Put this in a fragment? Or inside checkout success
const continueAsLabel = computed(() => {
    const firstName = props.checkoutResultData.includedInvoice
        ? props.checkoutResultData.data.customer.firstName
        : props.checkoutResultData.data.firstName

    return t('checkoutSuccess.continueAs', { name: firstName })
})
</script>
